import React, { useRef, useState } from 'react';
import './FileUpload.scss';
import Button from './Button';
import { ReactComponent as AddIcon } from '../assets/add_medium.svg';

type Props = {
  onChange: (event: File | undefined) => void;
  accept: string;
  text?: string;
};

const FileUpload: React.FC<Props> = ({ onChange, accept, text }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState<string>('');

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFileName(file.name);
      onChange(file);
    }
  };

  return (
    <div className="file-input-wrapper">
      <Button type="Outline" onClick={handleClick}>
        {text || 'Choose File'} <AddIcon />
      </Button>
      <span className="file-name">{fileName || 'No file chosen'}</span>
      <input
        type="file"
        accept={accept}
        ref={fileInputRef}
        className="file-hidden"
        onChange={handleChange}
      />
    </div>
  );
};

export default FileUpload;
